import { createRouter, createWebHistory } from 'vue-router'
import administracao from './administracao.js'

export const routes = [
  ...administracao,
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue'),
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/Realizados.vue'),
    meta: { breadcrumb: [{ title: 'Pedidos Realizados' }] },
  },
  {
    path: '/realizados',
    name: 'realizedOrders',
    component: () => import('@/views/Realizados.vue'),
    meta: { breadcrumb: [{ title: 'Pedidos Realizados' }] },
  },
  {
    path: '/meus-pedidos',
    name: 'myOrders',
    component: () => import('@/views/Realizados.vue'),
    meta: { breadcrumb: [{ title: 'Pedidos Realizados' }] },
  },
  {
    path: '/financeiro/pedidos-realizados',
    name: 'financialRealizedOrders',
    component: () => import('@/views/financeiro/PedidosRealizados.vue'),
    meta: { breadcrumb: [{ title: 'Financeiro' }, { title: 'Pedidos Realizados' }] },
  },
  {
    path: '/financeiro/metas',
    name: 'financialGoals',
    component: () => import('@/views/financeiro/MetasFinanceiro.vue'),
    meta: { breadcrumb: [{ title: 'Financeiro' }, { title: 'Metas' }] },
  },
  {
    path: '/financeiro/comissionamento/planos',
    name: 'commissionPlans',
    component: () => import('@/views/financeiro/comissionamento/PlanosComissionamento.vue'),
    meta: { breadcrumb: [{ title: 'Financeiro' }, { title: 'Comissionamento' }, { title: 'Planos' }] },
  },
  {
    path: '/financeiro/comissionamento/planos/novo',
    name: 'commissionPlansNew',
    component: () => import('@/views/financeiro/comissionamento/PlanoComissionamentoNew.vue'),
    meta: { breadcrumb: [{ title: 'Financeiro' }, { title: 'Comissionamento' }, { title: 'Novo Plano' }] },
  },
  {
    path: '/financeiro/comissionamento/planos/:id/editar',
    name: 'commissionPlansUpdate',
    component: () => import('@/views/financeiro/comissionamento/PlanoComissionamentoNew.vue'),
    meta: { breadcrumb: [{ title: 'Financeiro' }, { title: 'Comissionamento' }, { title: 'Editar Plano' }] },
  },
  {
    path: '/financeiro/comissionamento/planos/:id/regras',
    name: 'commissionPlansRules',
    component: () => import('@/views/financeiro/comissionamento/PlanoComissionamentoDetalhe.vue'),
    meta: { breadcrumb: [{ title: 'Financeiro' }, { title: 'Comissionamento' }, { title: 'Regras do Plano' }] },
  },
  {
    path: '/financeiro/comissionamento/simulacao',
    name: 'commissionCalculation',
    component: () => import('@/views/financeiro/comissionamento/SimulacaoComissionamento.vue'),
    meta: { breadcrumb: [{ title: 'Financeiro' }, { title: 'Comissionamento' }, { title: 'Simulação' }] },
  },
  {
    path: '/financeiro/comissionamento/recebimentos',
    name: 'financialReceipts',
    component: () => import('@/views/financeiro/comissionamento/RecebimentosComissionamento.vue'),
    meta: { breadcrumb: [{ title: 'Financeiro' }, { title: 'Comissionamento' }, { title: 'Recebimentos' }] },
  },
  {
    path: '/financeiro/pedidos-realizados-vendedora',
    name: 'financialSellerRealizedOrders',
    component: () => import('@/views/financeiro/PedidosRealizadosVendedora.vue'),
    meta: { breadcrumb: [{ title: 'Dashboard' }] },
  },
  {
    path: '/dashboard-vendedora',
    name: 'sellerDashboard',
    component: () => import('@/views/DashboardVendedora.vue'),
    meta: { breadcrumb: [{ title: 'Dashboard da Vendedora' }] },
  },
  {
    path: '/recebimentos',
    name: 'sellerReceipts',
    component: () => import('@/views/Recebimentos.vue'),
    meta: { breadcrumb: [{ title: 'Recebimentos' }] },
  },
  {
    path: '/minhas-metas',
    name: 'myGoals',
    component: () => import('@/views/MinhasMetas.vue'),
    meta: { breadcrumb: [{ title: 'Minhas Metas' }] },
  },
  {
    path: '/parcelas-sem-vencimento',
    name: 'missingDueDates',
    component: () => import('@/views/ParcelasSemVencimento.vue'),
    meta: { breadcrumb: [{ title: 'Parcelas sem vencimento' }] },
  },
  {
    path: '/',
    name: 'base',
    component: () => import('@/views/Realizados.vue'),
  },
  {
    path: '/meu_perfil',
    name: 'myProfile',
    component: () => import('@/views/Perfil.vue'),
    meta: { breadcrumb: [{ title: 'Meu Perfil' }] },
  },
  {
    path: '/acesso-restrito',
    name: 'acessoRestrito',
    component: () => import('@/views/AcessoRestrito.vue'),
  },
  {
    path: '/financeiro/comissoes-ingram',
    name: 'comissoesIngram',
    component: () => import('@/views/financeiro/ComissoesIngram.vue'),
    meta: { breadcrumb: [{ title: 'Financeiro' }, { title: 'Comissões Ingram' }] },
  },
  {
    path: '/integracoes/metas-crm',
    name: 'crmSellerGoalIntegration',
    component: () => import('@/views/integracoes/MetasCrm.vue'),
    meta: { breadcrumb: [{ title: 'Integrações CRM' }, { title: 'Metas CRM' }] },
  },
  {
    path: '/integracoes/parcelas-crm',
    name: 'crmSellerInstallmentIntegration',
    component: () => import('@/views/integracoes/ParcelasCrm.vue'),
    meta: { breadcrumb: [{ title: 'Integrações CRM' }, { title: 'Parcelas CRM' }] },
  },
  {
    path: '/integracoes/vendedores-crm',
    name: 'crmSellerUserIntegration',
    component: () => import('@/views/integracoes/VendedoresCrm.vue'),
    meta: { breadcrumb: [{ title: 'Integrações CRM' }, { title: 'Vendedores CRM' }] },
  },
  {
    path: '/integracoes/clientes-crm',
    name: 'crmCustomerIntegration',
    component: () => import('@/views/integracoes/ClientesCrm.vue'),
    meta: { breadcrumb: [{ title: 'Integrações CRM' }, { title: 'Clientes CRM' }] },
  },
  {
    path: '/integracoes/distribuidores-crm',
    name: 'crmDistributorIntegration',
    component: () => import('@/views/integracoes/DistribuidoresCrm.vue'),
    meta: { breadcrumb: [{ title: 'Integrações CRM' }, { title: 'Distribuidores CRM' }] },
  },
  {
    path: '/integracoes/vendedores-crm/:systemuserid',
    name: 'crmSellerUserIntegrationDetail',
    component: () => import('@/views/integracoes/VendedorCrmDetalhe.vue'),
    meta: { breadcrumb: [{ title: 'Integrações CRM' }, { title: 'Vendedores CRM' }, { title: 'Detalhe do Vendedor' }] },
  },
  {
    path: '/integracoes/clientes-crm/:accountid',
    name: 'crmCustomerIntegrationDetail',
    component: () => import('@/views/integracoes/ClienteCrmDetalhe.vue'),
    meta: { breadcrumb: [{ title: 'Integrações CRM' }, { title: 'Clientes CRM' }, { title: 'Detalhe do Cliente' }] },
  },
  {
    path: '/integracoes/distribuidores-crm/:distributorId',
    name: 'crmDistributorIntegrationDetail',
    component: () => import('@/views/integracoes/DistribuidorCrmDetalhe.vue'),
    meta: { breadcrumb: [{ title: 'Integrações CRM' }, { title: 'Distribuidores CRM' }, { title: 'Detalhe do Distribuidor' }] },
  },
  {
    path: '/integracoes/importacao-crm-comercial',
    name: 'crmCommercialImportIntegration',
    component: () => import('@/views/integracoes/ImportacaoCrmComercial.vue'),
    meta: { breadcrumb: [{ title: 'Integrações CRM' }, { title: 'Importação CRM Comercial' }] },
  },
  {
    path: '/integracoes/comissoes-ingram',
    name: 'ingramCommissionIntegration',
    component: () => import('@/views/integracoes/ImportacaoComissoesIngram.vue'),
    meta: { breadcrumb: [{ title: 'Ingram' }, { title: 'Integrações de Comissões' }] },
  },
  {
    path: '/integracoes/pedidos-ingram',
    name: 'ingramOrdersIntegration',
    component: () => import('@/views/integracoes/PedidosIngram.vue'),
    meta: { breadcrumb: [{ title: 'Ingram' }, { title: 'Envio de Pedidos' }] },
  },
  {
    path: '/integracoes/clientes-ingram',
    name: 'ingramCustomerMapping',
    component: () => import('@/views/integracoes/RelacionamentoClientesIngram.vue'),
    meta: { breadcrumb: [{ title: 'Ingram' }, { title: 'Vincular Clientes' }] },
  },
    {
      path: '/integracoes/produtos-crm-ingram',
      name: 'crmIngramProductMapping',
      component: () => import('@/views/integracoes/RelacionamentoProdutosIngram.vue'),
      meta: { breadcrumb: [{ title: 'Ingram' }, { title: 'Vincular Produtos' }] },
    },
  {
    path: '/integracoes/produtos-crm',
    name: 'crmProductsIntegration',
    component: () => import('@/views/integracoes/ProdutosCrm.vue'),
    meta: { breadcrumb: [{ title: 'Integrações CRM' }, { title: 'Produtos CRM' }] },
  },
  {
    path: '/integracoes/pedidos-crm',
    name: 'crmOrdersValidator',
    component: () => import('@/views/integracoes/PedidosCrmValidador.vue'),
    meta: { breadcrumb: [{ title: 'Integrações CRM' }, { title: 'Pedidos CRM' }] },
  },
  {
    path: '/ingram/produtos',
    name: 'ingramProducts',
    component: () => import('@/views/ingram/ProdutosIngram.vue'),
    meta: { breadcrumb: [{ title: 'Ingram' }, { title: 'Produtos Ingram' }] },
  },
  {
    path: '/ingram/pedidos-marketplace',
    name: 'ingramMarketplaceOrders',
    component: () => import('@/views/ingram/PedidosMarketplace.vue'),
    meta: { breadcrumb: [{ title: 'Ingram' }, { title: 'Pedidos Ingram' }] },
  },
  {
    path: '/ingram/pipeline-pedidos',
    name: 'ingramOrdersPipeline',
    component: () => import('@/views/ingram/PedidosPipeline.vue'),
    meta: { breadcrumb: [{ title: 'Ingram' }, { title: 'Pipeline de Pedidos' }] },
  },
  {
    path: '/conta-azul/empresas',
    name: 'contaAzulCompany',
    component: () => import('@/views/contaAzul/EmpresasContaAzul.vue'),
    meta: { breadcrumb: [{ title: 'Conta Azul' }, { title: 'Empresas Conta Azul' }] },
  },
  {
    path: '/conta-azul/integracao-pedidos',
    name: 'contaAzulOrderIntegration',
    component: () => import('@/views/contaAzul/IntegracaoPedidosContaAzul.vue'),
    meta: { breadcrumb: [{ title: 'Conta Azul' }, { title: 'Integração de Pedidos' }] },
  },
  {
    path: '/conta-azul/parametrizacao',
    name: 'contaAzulSettings',
    component: () => import('@/views/contaAzul/ParametrizacaoContaAzul.vue'),
    meta: { breadcrumb: [{ title: 'Conta Azul' }, { title: 'Parametrização' }] },
  },
]

const normalizePath = (path) => {
  const raw = String(path || '').toLowerCase().trim()
  if (!raw) return '/'

  const onlyPath = raw.split('?')[0].split('#')[0]
  const normalized = onlyPath.replace(/^\/+/g, '').replace(/\/+$/g, '')
  return normalized ? `/${normalized}` : '/'
}

const routeTemplateToRegex = (routeTemplate) => {
  const normalizedTemplate = normalizePath(routeTemplate)
  const escaped = normalizedTemplate.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  const withParams = escaped.replace(/:([a-zA-Z0-9_]+)/g, '[^/]+')
  return new RegExp(`^${withParams}$`, 'i')
}

const matchesRoute = (path, routeTemplate) => {
  if (!routeTemplate) {
    return false
  }
  const regex = routeTemplateToRegex(routeTemplate)
  return regex.test(path)
}

const getStoredUser = () => {
  const rawUser = localStorage.getItem('user')
  if (!rawUser || rawUser === 'undefined' || rawUser === 'null') {
    return null
  }

  try {
    return JSON.parse(rawUser)
  } catch (error) {
    return null
  }
}

const canAccessRoute = (toPath, user) => {
  const alwaysAllowed = new Set([
    '/home',
    '/',
    '/realizados',
    '/meus-pedidos',
    '/meu_perfil',
    '/acesso-restrito',
    '/parcelas-sem-vencimento',
  ])
  const path = normalizePath(toPath)

  if (alwaysAllowed.has(path)) {
    return true
  }

  const permissions = user?.permissions?.byScreenRoute || {}
  const entries = Object.entries(permissions)
  if (!entries.length) {
    return false
  }

  return entries.some(([screenRoute, permission]) => {
    if (!permission?.get) {
      return false
    }

    return matchesRoute(path, screenRoute)
  })
}

const shouldUseSellerDashboardHome = (user) => {
  return !!user?.permissions?.byScreenRoute?.['/dashboard-vendedora']?.get
}

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

router.beforeEach((to) => {
  const targetPath = normalizePath(to.path)
  const user = getStoredUser()

  if (targetPath === '/login') {
    return true
  }

  if (!user?.id) {
    return { path: '/login' }
  }

  if ((targetPath === '/' || targetPath === '/home') && shouldUseSellerDashboardHome(user)) {
    return { path: '/dashboard-vendedora' }
  }

  if (!canAccessRoute(to.path, user)) {
    return { path: '/acesso-restrito' }
  }

  return true
})

export default router
